import { Inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { APP_CONFIG } from '../configuration/ticket-management-portal-configuration'
import { TicketManagementPortalConfiguration } from '../configuration/ticket-management-portal-configuration.model'
import { UserService } from '../services'
import { DjangoSessionAuthenticationService } from '../services/django-session-authentication.service'

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

  constructor(private authService: DjangoSessionAuthenticationService,
              @Inject(APP_CONFIG) public app_config: TicketManagementPortalConfiguration,
              private router: Router,
              private userService: UserService) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authService.getUserLogged().then((user) => {
      if(user) {
            this.app_config.rules.isTaxesBreakdownEnabled = user['has_service_charge'] || false
      }
      this.userService.clearUrl();
      if (!user) {
        this.router.navigate(['/login']);
        return false;
      } else if (user.type === 'superadmin') {
        return false;
      } else {
        if (this.app_config.endDate && new Date(this.app_config.endDate)) {
          if (new Date() > new Date(this.app_config.endDate)) {
            this.router.navigate(['/login']);
            return false;
          }
        }
        return true;
      }
      // @ts-ignore
    }, Error((e) => {
      return false;
    }));
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

      return this.authService.canActivate();

  }

}
